angular.module('TetherApp').controller('LaunchpadController', [function () {}]);
